import { createContext, useContext, useState } from "react";

export const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({
  children,
 
}) => {
  const [journeyConfigRowData, setJourneyConfigRowData] = useState(null);
 

  return (
    <AppContext.Provider
      value={{
        journeyConfigRowData,
        setJourneyConfigRowData
        
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
